/* eslint-disable class-methods-use-this */

import * as React from 'react';
import { Box } from '@chakra-ui/react';
import {
  CellTemplate,
  Cell,
  Compatible,
  Uncertain,
  getCellProperty,
  isAlphaNumericKey,
  isNavigationKey,
} from '@silevis/reactgrid';

import { TableCheckBox } from './TableCheckBox';

export interface SelectCell extends Cell {
  text: string;
  isHeading: boolean;
  itemId: number;
}

export class SelectCellTemplate implements CellTemplate<SelectCell> {
  getCompatibleCell(uncertainCell: Uncertain<SelectCell>): Compatible<SelectCell> {
    const text = getCellProperty(uncertainCell, 'text', 'string');
    const value = Number.parseFloat(text);
    return { ...uncertainCell, text, value } as Compatible<SelectCell>;
  }

  getClassName(cell: Compatible<SelectCell>): string {
    const className = cell.className || '';
    return `${className}`;
  }

  render(cell: Compatible<SelectCell>): React.ReactNode {
    const { isHeading, itemId } = cell || {};

    const handleKeyDown = (event: React.KeyboardEvent) => {
      if (isAlphaNumericKey(event.keyCode) || isNavigationKey(event.keyCode))
        event.stopPropagation();
    };

    const handleClick = (event: any) => {
      if (isAlphaNumericKey(event.keyCode) || isNavigationKey(event.keyCode))
        event.stopPropagation();
    };

    // ReactGrid's pane-level pointerdown handler preventDefaults the event
    // to support drag-to-select cell ranges. For a native checkbox <input>,
    // that preventDefault also suppresses the browser's own click-to-toggle
    // activation, so the box visually renders but clicking it does nothing.
    // Stopping propagation here (before it reaches ReactGrid's handler)
    // keeps the checkbox's native toggle behavior intact, same fix already
    // applied to the modern dropdown's MenuList in components/DropdownCell.
    //
    // This box fills the whole cell (34px tall), but the checkbox control
    // itself is only 16px, so most of the cell is just padding around it.
    // Row drag-to-reorder is this column's other job — ReactGrid only
    // arms it on a pointerdown it receives here — so stopping propagation
    // for the padding too (not just the checkbox) silently ate every drag
    // that didn't start on the exact 16px control, which is what made
    // dragging feel like it only worked sometimes.
    const handlePointerDown = (event: any) => {
      if (event.target.closest('.chakra-checkbox')) {
        event.stopPropagation();
      }
    };

    return (
      <Box
        onClick={handleClick}
        onKeyDown={handleKeyDown}
        onPointerDown={handlePointerDown}
        display='flex'
        alignItems='center'
        justifyContent='center'
        width='100%'
        height='100%'
        position='relative'
        zIndex={2}
      >
        <TableCheckBox isHeading={isHeading} itemId={itemId} />
      </Box>
    );
  }
}
